var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJackpot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD6DD",
    d: "M11 24c0 2.209-.791 3-3 3H4c-2.209 0-3-.791-3-3V12c0-2.209.791-3 3-3h4c2.209 0 3 .791 3 3v12zm12 0c0 2.209-.791 3-3 3h-4c-2.209 0-3-.791-3-3V12c0-2.209.791-3 3-3h4c2.209 0 3 .791 3 3v12zm12 0c0 2.209-.791 3-3 3h-4c-2.209 0-3-.791-3-3V12c0-2.209.791-3 3-3h4c2.209 0 3 .791 3 3v12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M1 13h10v10H1zm12 0h10v10H13zm12 0h10v10H25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE1931",
    d: "M30.795 15.685h-2.816c-.594 0-.813-.385-.813-.759c0-.385.209-.759.813-.759h3.983c.561 0 .792.506.792.792c0 .22-.121.451-.253.726l-2.729 5.545c-.308.615-.429.836-.925.836c-.604 0-.912-.463-.912-.781c0-.133.033-.232.109-.385l2.751-5.215zm-12 0h-2.816c-.594 0-.814-.385-.814-.759c0-.385.209-.759.814-.759h3.983c.561 0 .792.506.792.792c0 .22-.121.451-.253.726l-2.729 5.545c-.308.615-.429.836-.924.836c-.605 0-.913-.463-.913-.781c0-.133.033-.232.11-.385l2.75-5.215zm-12 0H3.979c-.594 0-.814-.385-.814-.759c0-.385.209-.759.814-.759h3.983c.561 0 .792.506.792.792c0 .22-.121.451-.253.726L5.772 21.23c-.308.615-.429.836-.924.836c-.605 0-.913-.463-.913-.781c0-.133.033-.232.11-.385l2.75-5.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9266CC",
    d: "M3.061 9A2.08 2.08 0 0 0 3 9.5C3 10.881 4.343 12 6 12s3-1.119 3-2.5a2.08 2.08 0 0 0-.061-.5H3.061zm12 0a2.08 2.08 0 0 0-.061.5c0 1.381 1.343 2.5 3 2.5c1.656 0 3-1.119 3-2.5c0-.171-.021-.338-.06-.5h-5.879zM27.06 9c-.039.162-.06.329-.06.5c0 1.381 1.344 2.5 3 2.5s3-1.119 3-2.5a2.08 2.08 0 0 0-.061-.5H27.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4900C",
    d: "M8.816 27A.868.868 0 0 0 9 26.5c0-.828-1.343-1.5-3-1.5s-3 .672-3 1.5c0 .176.072.343.184.5h5.632zm12 0a.868.868 0 0 0 .184-.5c0-.828-1.344-1.5-3-1.5c-1.657 0-3 .672-3 1.5c0 .176.072.343.184.5h5.632zm12 0a.868.868 0 0 0 .184-.5c0-.828-1.344-1.5-3-1.5s-3 .672-3 1.5c0 .176.072.343.184.5h5.632z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpot);
export default __webpack_public_path__ + "static/media/jackpot.28ceca45f444ee74d029b0cd0a82706f.svg";
export { ForwardRef as ReactComponent };